class config {
  /*
   * Return dynamic url based on host
   */
  getHost = () => {
    const host = window.location.host;
    const proto = window.location.protocol;
    // eslint-disable-next-line
    if (host.substring(host, 9) === "localhost") {
      //local URL for api
      // return `https://api.qa.doodycalls.com/api/v1/`;
      return `https://api.dev.doodycalls.com/api/v1/`;
    } else {
      //live
      // eslint-disable-next-line
      if (host === "crm.dev.doodycalls.com") {
        return `https://api.dev.doodycalls.com/api/v1/`;
      }
      if (host === "dev-crm.doodycalls.com") {
        return `https://dev-api.doodycalls.com/api/v1/`;
      }
      // eslint-disable-next-line
      else if (host === "stage-crm.doodycalls.com") {
        return `https://stage-api.doodycalls.com/api/v1/`;
      }
      // eslint-disable-next-line
      else if (host === "uat-crm.doodycalls.com") {
        return `https://uat-api.doodycalls.com/api/v1/`;
      }
      // eslint-disable-next-line
      else if (host === "crm.dcdev.dev.authoritybrandsllc.com") {
        // return `https://crm.dev.doodycalls.com/`;
      }
      // eslint-disable-next-line
      else if (host === "www.crm.dcdev.dev.authoritybrandsllc.com") {
        // return `https://crm.dev.doodycalls.com/`;
      } else if (host === "crm.qa.doodycalls.com") {
        return `https://api.qa.doodycalls.com/api/v1/`;
      }
      // eslint-disable-next-line
      else if (host === "crm.doodycalls.com") {
        return `https://api.doodycalls.com/api/v1/`;
      } else if (host === "crm.uat.doodycalls.com") {
        return `https://api.uat.doodycalls.com/api/v1/`;
      } else {
        return `${proto}//api.${host}/api/v1/`;
      }
    }
  };
}
export default new config();
